export const RECENT_CONNECTION_FOR_ENDPOINT = 'RECENT_CONNECTION_FOR_ENDPOINT';
export const RECENT_CONNECTION = (email: string) =>
  `RECENT_CONNECTION-${email}`;
